import { React, PT } from '@gasbuddy/react';
import { Grid, Button, Divider } from 'semantic-ui-react';
import { PoiLocation, PoiBrand } from '../..';

export const WexMatcherPotential = ({ singleStationDetails, stationDetails, confirmFunc }) => {
  const singleStringPlace = `${singleStationDetails.address.line_1} ${singleStationDetails.address.locality} ${singleStationDetails.address.region}`;
  const stringPlace = `${stationDetails.address.line_1} ${stationDetails.address.locality} ${stationDetails.address.region}`;
  return (
    <>
      <Grid.Column width={3} textAlign="center">
        <PoiLocation poi={stationDetails} />
        <Divider horizontal />
        <div>
          <a
            href={`https://www.google.com/maps/dir/${encodeURIComponent(singleStringPlace)}/${encodeURIComponent(stringPlace)}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            Compare In Google Maps
          </a>
          <Divider horizontal />
        </div>
        <div>
          <Button
            primary
            onClick={confirmFunc}
            icon="check circle"
            labelPosition="left"
            content="Confirm Match"
          />
        </div>
      </Grid.Column>
      { stationDetails.brandings
        ? (
          <Grid.Column>
            <PoiBrand brands={stationDetails.brandings} />
          </Grid.Column>
        ) : ''
      }
    </>
  );
};

WexMatcherPotential.defaultProps = {
  stationDetails: [],
};

WexMatcherPotential.propTypes = {
  singleStationDetails: PT.shape({
    brandings: PT.arrayOf(PT.shape({
      brand_id: PT.isnumber,
      branding_type: PT.string,
      image_url: PT.string,
    })),
  }).isRequired,
  stationDetails: PT.arrayOf(PT.shape({
    brandings: PT.arrayOf(PT.shape({
      brand_id: PT.isnumber,
      branding_type: PT.string,
      image_url: PT.string,
    })),
  })),
  confirmFunc: PT.func.isRequired,
};
